/* eslint-disable max-len */
import _ from 'underscore';
import { targetOptions } from '@bingads-webui-campaign-react/location-targeting';
import { formatGenders, formatAgeRanges } from '@bingads-webui-campaign-react/audience-demographic';

export const getLocationTargetsEditorStrings = i18n => ({
  noResultsMessage: i18n.getString(_TL_('Location does not exist or cannot be targeted. Enter a new location or add a radius around a location.')),
  description: i18n.getString(_TL_('For example, coordinates, ZIP/postal code, state/province, or country/region.')),
  label: i18n.getString(_TL_('Search for location')),
  choiceGroupLabel: i18n.getString(_TL_('I want to target:')),
  boundaryOption: i18n.getString(_TL_('Specific location')),
  radiusOption: i18n.getString(_TL_('Radius around a point')),
});

export const buildLocationTargetingData = ({
  isPeopleInLocationChecked,
  isPeopleSearchingForLocationChecked,
  selectedLocationOption,
  negativeLocationTargets,
  positiveLocationTargets,
}) => ({
  isPeopleInLocationChecked: _.isUndefined(isPeopleInLocationChecked) ? true : isPeopleInLocationChecked,
  isPeopleSearchingForLocationChecked: _.isUndefined(isPeopleSearchingForLocationChecked) ? true : isPeopleSearchingForLocationChecked,
  selectedLocationOption: selectedLocationOption || targetOptions.specific,
  negativeLocationTargets: negativeLocationTargets || [],
  positiveLocationTargets: positiveLocationTargets || [],
});

export function shouldSelectQuickOption(quickOptionCountry, savedTargets, suggestedTargets) {
  const {
    positiveLocationTargets = [],
    negativeLocationTargets = [],
  } = savedTargets || {};

  if (_.isEmpty(suggestedTargets) && _.isEmpty(savedTargets)) {
    return true;
  }

  if (
    quickOptionCountry
    && positiveLocationTargets.length === 1
    && positiveLocationTargets[0].location
    && positiveLocationTargets[0].location.Id === quickOptionCountry.Id
    && _.isEmpty(negativeLocationTargets)
  ) {
    return true;
  }

  return false;
}

export const getLocationSummary = (targets, i18n) => _.map(targets, (target) => {
  const {
    radiusDescription,
    locationDescription,
  } = target.getGridRowText(i18n);
  return `${radiusDescription} ${locationDescription}`;
}).join('; ');

export const getLocationTargetTitleDetails = (includedLocations, excludedLocations, targetOption, i18n) => {
  if (targetOption === targetOptions.everywhere) {
    return i18n.getString(_TL_('Targeting everywhere.'));
  }

  const includedLocationsString = getLocationSummary(includedLocations, i18n);
  const excludedLocationsString = getLocationSummary(excludedLocations, i18n);

  let finalizedString = '';
  if (includedLocations.length) {
    finalizedString += `${i18n.getString(_TL_('Included locations: '))}${includedLocationsString}. `;
  }
  if (excludedLocationsString.length) {
    finalizedString += `${i18n.getString(_TL_('Excluded locations: '))}${excludedLocationsString}. `;
  }

  return finalizedString;
};

export const getDemographicsDetails = (ageRanges, genderTypes, i18n) => {
  if (_.isEmpty(ageRanges) || _.isEmpty(genderTypes)) {
    return '';
  }

  const ages = formatAgeRanges(ageRanges, i18n);
  const genders = formatGenders(genderTypes, i18n);

  return `${ages}; ${genders}`;
};

export const getSearchThemeDetails = (i18n, searchThemes) => {
  const selected = searchThemes && searchThemes.filter(item => item.Status !== 'Deleted');
  if (selected && selected.length > 0) {
    return selected.map(item => item.SearchTheme).join(',');
  }
  return i18n.getString(_TL_('No search themes added'));
};
